import { TableChart } from '@mui/icons-material';
import { Card, Stack, Typography } from '@mui/material';

export default function AdyenUnconnected(): JSX.Element {
  return (
    <Stack gap={2}>
      <Card sx={{ py: 8 }}>
        <Stack sx={{ px: 4 }} gap={2} alignItems="center">
          <Card
            sx={{
              width: 72,
              height: 72,
              p: 2,
              backgroundColor: 'grey.100',
              boxShadow: 'none',
            }}
          >
            <TableChart color="secondary" sx={{ width: 40, height: 40 }} />
          </Card>
          <Typography variant="h4" color="text.primary" fontWeight="bold" textAlign="center">
            No active Adyen integration found
          </Typography>

          <Typography variant="h6" color="text.secondary" textAlign="center">
            Your Adyen integration details will show up here.
          </Typography>
        </Stack>
      </Card>
    </Stack>
  );
}
